// Global
import { Feature } from 'src/.generated/Feature.EnterpriseWeb.model';
import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
// Components
import Component from 'src/helpers/Component/Component';
import Script from 'next/script';

import { ComponentProps } from 'lib/types/component-props';
import Head from 'next/head';
export type ProductDiscoveryProps =
  Feature.EnterpriseWeb.AndersenWindows.Components.Tool.ProductDiscovery & ComponentProps;

const ProductDiscovery = (props: ProductDiscoveryProps) => {
  if (!props.fields) {
    return <></>;
  }

  return (
    <>
      <Head>
        <link href={props.fields.stylesheetHref?.value} rel="stylesheet" />
      </Head>
      <Script src={props.fields.scriptSource?.value} />
      <Component variant="full" grid="none" dataComponent="product/productdiscovery" {...props}>
        <div id="tk-discoveryai"></div>
      </Component>
    </>
  );
};

export default withDatasourceCheck()<ProductDiscoveryProps>(ProductDiscovery);
